module.exports = __webpack_public_path__ + "Mood_www10.mov?f31c5dbb83c1403c4a7ee87e88c8d204";